/**
 * @description: 经理实收报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="jls-report">
        <div class="jls-list" v-show="!showJlsBill && !showJlsOrder">
            <p class="p-hint">注：1、当天营业数据就只能单个营业日，历史数据支持一个月内的数据查询</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="jlsTime">
                        <input type="text" class="form-control laydate-icon" v-model="jlsStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="jlsEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="jlsShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="jlsperf_tit_sel">
                        <option value="room_name">包厢号</option>
                        <option value="order_id">单据编号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="jlsperf_con_val" :placeholder="jlsperf_con_phd">
                </div>
                <label class="list-label-3">操作人:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="jls_admin" data-placeholder="请选择操作人"></select>
                </div>
            </div>
            <div class="row row-margin">
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="getJlsList(1)" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getJlsExportSet">导出</button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="jls_list_table">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="timestamp" label="下单时间"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column label="单据编号">
                    <template slot-scope="scope">
						<span class="text-blue" @click="jlsDetail(scope.row)">{{scope.row.order_id}}</span>
					</template>
                </el-table-column>
                <el-table-column prop="balance" label="经理实收差额"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">经理实收差额:</label>
                    <div class="list-total">{{jls_balance_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="jls_list_page"
                    :total="jls_list_total"
                    @current-change="getJlsList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="jlsExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='jlsExport_allcheck' @click='jlsExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jlsExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jlsExport_checkModel' value="timestamp">
                            <label>下单时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jlsExport_checkModel' value="admin_name">
                            <label>操作人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jlsExport_checkModel' value="order_id">
                            <label>单据编号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='jlsExport_checkModel' value="balance">
                            <label>经理实收差额</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='jlsExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='jlsExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="jls-bill" v-show="showJlsBill">
            <billDetail ref="jls_bill_det" @backBdwPre="showJlsBill = false"></billDetail>
        </div>
        <div class="jls-order" v-show="showJlsOrder">
            <orderDetail ref="jls_order_det" @backOdwPre="showJlsOrder = false"></orderDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    import orderDetail from '@/components/order_detail.vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                showJlsBill: false,
                showJlsOrder: false,
                jlsStartTime: "",
                jlsEndTime: "",
                jlsperf_con_val: "",
                jlsperf_con_phd: "请输入包厢号",
                jlsperf_field: "room_name",
                jls_list_table: [],
				jls_list_page: 1,
                jls_list_total: 0,
                jls_balance_total: '',
                jlsExport_allcheck: false,
                c_jlsExport_allcheck: false,
                jlsExport_checkModel: [],
                jlsExport_checkData: ['room_name', 'timestamp', 'admin_name', 'order_id', 'balance'],
                jlsExport_type: 1,
            }
        },
        components: {
            "orderDetail": orderDetail,
			"billDetail": billDetail
        },
        watch: {
            jlsExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.jlsExport_checkModel.length >= this.jlsExport_checkData.length) {
                        this.jlsExport_allcheck = true;
                        this.c_jlsExport_allcheck = true;
                    } else {
                        this.jlsExport_allcheck = false;
                        this.c_jlsExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.jlsStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.jlsEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.jlsperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.jlsperf_field = $(this).val();
                if(_this.jlsperf_field == 'room_name') {
                    _this.jlsperf_con_phd = '请输入包厢号';
                } else if(_this.jlsperf_field == 'order_id') {
                    _this.jlsperf_con_phd = '请输入单据编号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.jlsStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jlsEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.jlsStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.jlsEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.jlsTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    maxDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.jlsStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.jlsEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                if (v.id != '0') {
                                    _this.shopDatas.push({
                                        id: v.id,
                                        text: v.name
                                    });
                                }
                            });
                            $(_this.$refs.jlsShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                // 操作人
                                _this.getAdminData('jls', e.params.data.id);
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.jlsShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            // 操作人
                            _this.getAdminData('jls', $(_this.$refs.jlsShop).val());
                            _this.getJlsList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取操作人数据
            getAdminData: function(shop_id) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.jls_admin).html("");
                            $(_this.$refs.jls_admin).select2({
                                data: arr,
                                language: "zh-CN",
                                width: '100%'
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            getJlsList(page) {
				const _this = this;

                _this.loading = true;
                _this.jls_list_page = page
				Vue.axios.post('FinanceReport/managerAmountReportList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.jlsStartTime,
                            "end_date": _this.jlsEndTime,
                            "shop_id": $(_this.$refs.jlsShop).val(),
                            "key_word": _this.jlsperf_field,
                            "search_word": _this.jlsperf_con_val,
                            "admin_id": $.trim($(_this.$refs.jls_admin).val())
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.jls_list_total = Number(res.data.response.result.count);
							_this.jls_balance_total = res.data.response.result.balance_total;
						}
						_this.jls_list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},
            jlsDetail(row) {
                if(row.type == '1') {
                    this.$refs.jls_order_det.getOdwDetail(row.order_id);
                    this.showJlsOrder = true;
                } else {
                    this.$refs.jls_bill_det.getBdwDetail(row.order_id);
                    this.showJlsBill = true;
                }
            },
            // 获取导出设置
            getJlsExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/managerAmountReportListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.jlsExport_checkModel = data.response.result.export_fields;
                                _this.jlsExport_type = data.response.result.export_type;
                            } else {
                                _this.jlsExport_checkModel = _this.jlsExport_checkData;
                                _this.jlsExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.jlsExport_alert)
                }, function() {
                    _this.exportJlsList();
                });
            },
            // 导出字段全选
            jlsExportCheckedAll: function() {
                let _this = this;
                _this.jlsExport_allcheck = _this.c_jlsExport_allcheck;
                if(!_this.jlsExport_allcheck) { // 实现全选
                    _this.jlsExport_checkModel = [];
                    _this.jlsExport_checkData.forEach(function(item) {
                        _this.jlsExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.jlsExport_checkModel = [];
                }
            },
            // 导出经理实收报表
            exportJlsList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.jlsShop).val();
                let export_fields = JSON.stringify(_this.jlsExport_checkModel);
                window.location.href = Vue.ctUrl + "FinanceReport/managerAmountReportListExport?" +
                    "&start_date=" + _this.jlsStartTime +
                    "&end_date=" + _this.jlsEndTime +
                    "&shop_id=" + shop_id +
                    "&key_word=" + _this.jlsperf_field +
                    "&search_word=" + _this.jlsperf_con_val +
                    "&admin_id=" + $.trim($(_this.$refs.jls_admin).val()) +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.jlsExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>